export default class Helper {
    private static readonly productionOrigin = 'https://batuice.com'

    static isBetaDeployment(): boolean {
        return window.location.hostname === 'beta.batu-ice.pages.dev'
    }

    static getCanonicalURL(): string {
        let cleanURL = new URL(window.location.href)
        // excludes query / params
        const origin = this.isBetaDeployment() ? this.productionOrigin : cleanURL.origin
        cleanURL = new URL(origin + cleanURL.pathname)
        return cleanURL.toString();
    }
}
